import { useMutation } from '@tanstack/react-query'
import { getInvoicePreview } from 'api/payment'
import fileDownload from 'js-file-download'

const INVOICE_PREVIEW_FILENAME = 'workwhile_pending_invoice_charges.csv'

export function useInvoicePreviewDownloadMutation(companyId?: number) {
  return useMutation({
    mutationFn: async () => {
      if (companyId === undefined) {
        throw new Error('Company is required')
      }

      const csv = await getInvoicePreview(companyId)
      fileDownload(csv, INVOICE_PREVIEW_FILENAME)
    },
  })
}
